import { useTranslation } from "react-i18next";
import { Grid, Icon } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { APPOINTMENT_NOTE_TYPES } from "models";
import "modules/AppointmentDetails/components/CommunicationLogReplacementCar/CommunicationLogReplacementCar.scss";
import { formatDate } from "utils/dateHelperFunctions";

import type { Appointment } from "models";

enum REPLACEMENT_VEHICLE_TYPE {
  Vehicle = "huurauto",
  Bicycle = "huurfiets"
}

export const CommunicationLogReplacementCar = ({ appointment }: { appointment: Appointment }) => {
  const { t } = useTranslation();

  const replacementCarNote = appointment.notes?.find(note => note.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.ReplacementVehicle);

  if (!replacementCarNote) return null;

  const replacementVehicleNote =
    replacementCarNote.note.toLowerCase() === REPLACEMENT_VEHICLE_TYPE.Vehicle
      ? t("v8_replacement_vehicle_rental", "Replacement Vehicle Rental")
      : t("v8_replacement_bicycle_rental", "Replacement Bicycle Rental");

  const { rental_pickup_time, rental_drop_off_time } = replacementCarNote;

  return (
    <div className="CommunicationLogReplacementCar">
      <div className="section-header">
        <span>{t("v8_replacement_car", "Replacement Car")}</span>
      </div>
      <div className="section-content">
        <Grid>
          <Grid.Column width={4}>
            <span className="icon-text">{t("v8_reg", "Reg")} #</span> {replacementCarNote.reg_nr}
          </Grid.Column>

          <Grid.Column width={12}>
            <Icon className="clock i-green mr-5" />
            {replacementVehicleNote}{" "}
            {rental_pickup_time && <span className="CarReplacement__pickupTime">{formatDate(rental_pickup_time, DATE_FORMATS_FNS.dateMonthYearTime)}</span>}
            {rental_drop_off_time && <span> &gt; {formatDate(rental_drop_off_time, DATE_FORMATS_FNS.dateMonthYearTime)}</span>}
          </Grid.Column>
        </Grid>
      </div>
    </div>
  );
};
